export default "__VITE_ASSET__BwhD$3Yz__"